/* eslint-disable max-len */
import React, { ReactNode } from 'react';
import { tp } from 'app/utils/typograf';

export type TopDishType = {
    title: {
        firstLine: string,
        secondLine: string,
    },
    description: string | ReactNode
}
export type TopDishesRecord = Record<string, TopDishType>

export const topDishes: TopDishesRecord = {
    25: {
        title: {
            firstLine: 'Вкуснейший',
            secondLine: 'Том ям за 15 минут',
        },
        description: 'Сварили бульон, нашли специи и заправки из Тайланда и добавили много морепродуктов, чтобы вы приготовили тот самый тайский суп дома, как в ресторане.',
    },
    5050: {
        title: {
            firstLine: 'Сладкая вечеринка',
            secondLine: 'Уэнсдей',
        },
        description: 'Шоколадные капкейки с сиреневым кремом, загадочный чёрный лимонад и приятные мелочи для сервировки — всё для создания атмосферы сериала',
    },
    5433: {
        title: {
            firstLine: 'Празднуем Сабантуй',
            secondLine: '',
        },
        description: <>
            {tp.execute('Всё для приготовления эчпочмаков, как в Казани: готовое тесто, начинка и видео-инструкция.')}
            <br />
            {tp.execute('Собрали за 15 минут — и в духовку!')}
        </>,
    },
    4695: {
        title: {
            firstLine: 'Страшно вкусный бокс',
            secondLine: 'на Хэллоуин',
        },
        description: <>
            {tp.execute('Настоящая вечеринка всего за час — ужасно вкусные блюда, паутины, летучие мыши и, конечно, тыквенная голова Джека.')}
        </>,
    },
};
